import { useState } from 'react';
import { useDosageStorage } from './useDosageStorage';
import { useDosageImportExport } from './useDosageImportExport';
import type { SuggestedDosage } from '../../../types/data';

export const useSuggestedDosages = () => {
  const [showForm, setShowForm] = useState(false);
  const [editingDosage, setEditingDosage] = useState<SuggestedDosage | undefined>();
  
  const {
    dosages,
    saveDosage,
    deleteDosage,
    clearDosages,
    refreshDosages
  } = useDosageStorage();

  const {
    handleExport,
    handleImport
  } = useDosageImportExport(refreshDosages);

  const handleSubmit = (dosage: SuggestedDosage) => {
    saveDosage(dosage);
    setShowForm(false);
    setEditingDosage(undefined);
  };

  const handleEdit = (dosage: SuggestedDosage) => {
    setEditingDosage(dosage);
    setShowForm(true);
  };

  const handleDelete = (id: string) => {
    if (window.confirm('Are you sure you want to delete this suggested dosage?')) {
      deleteDosage(id);
    }
  };

  const handleCancel = () => {
    setShowForm(false);
    setEditingDosage(undefined);
  };

  const handleClear = () => {
    if (window.confirm('Are you sure you want to clear all suggested dosages? This action cannot be undone.')) {
      clearDosages();
    }
  };

  return {
    dosages,
    showForm,
    editingDosage,
    handleSubmit,
    handleEdit,
    handleDelete,
    handleCancel,
    handleClear,
    handleExport,
    handleImport,
    handleRefresh: refreshDosages,
    setShowForm
  };
};